<template>
    <div class="signDeployBox">
        <avue-crud :data="data"  ref="crud" :option="option" :page.sync="page">
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" type="primary" @click="dialogVisible = true">新增签署方</el-button>
                <el-button class="custom" type="primary" @click="nextBtn">下一步</el-button>
            </template>
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="editBtn(scope.row)">编辑签署方</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="deleteBtn(scope.row)">删除签署方</el-dropdown-item>
            </template>
        </avue-crud>
<!--        新增签署方-->
        <el-dialog
            title="新增签署方"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="40%">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="签署方" prop="zt_name">
                    <el-input v-model="form.zt_name" style="width: 80%" placeholder="请输入主体名称代号（如甲方或乙方等）"></el-input>
                </el-form-item>
                <el-form-item label="签署方类型" prop="zt_type">
                    <el-select v-model="form.zt_type" style="width: 80%" placeholder="请选择主体类型">
                        <el-option label="企业" value="1"></el-option>
                        <el-option label="个人" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelBtn">取 消</el-button>
                <el-button type="primary" @click="addBtn">确 定</el-button>
            </span>
        </el-dialog>
<!--        编辑签署方-->
        <el-dialog
            title="编辑签署方"
            :visible.sync="dialogVisible_edit"
            :close-on-click-modal="false"
            width="40%">
            <el-form ref="form" :model="editForm" label-width="120px">
                <el-form-item label="签署方" prop="zt_name">
                    <el-input v-model="editForm.zt_name" style="width: 80%" placeholder="请输入主体名称代号（如甲方或乙方等）"></el-input>
                </el-form-item>
                <el-form-item label="签署方类型" prop="zt_type">
                    <el-select v-model="editForm.zt_type" style="width: 80%" placeholder="请选择主体类型">
                        <el-option label="企业" :value="1"></el-option>
                        <el-option label="个人" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible_edit = false">取 消</el-button>
                <el-button type="primary" @click="confirmEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { addSignDeploy, deleteSignDeploy, editSignDeploy, nextEditTemplate, viewSignDeploy } from '@/api/template_kh';

export default {
    name: 'signDeploy',
    data(){
        return{
            dialogVisible:false,
            dialogVisible_edit:false,
            form:{
                tpl_id:'',
                zt_name:'',
                zt_type:'2',
            },
            editForm:{
                id:'',
                zt_name:'',
                zt_type:'',
            },
            data:[],
            page:{
                currentPage: 1,
                total: 20,  //总数
                pageSize: 20
            },
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: false, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuWidth: 150,  //操作栏宽度设置
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '签署方配置ID',
                        prop: 'id',
                        width: '100'
                    },
                    {
                        label: '主体名称代号',
                        prop: 'zt_name'
                    },
                    {
                        label: '主体类型',
                        prop: 'zt_type_txt'
                    },
                    {
                        label: '签署区自定义控件编码区间',
                        prop: 'zuoyou'
                    },
                    {
                        label: '更新时间',
                        prop: 'update_time'
                    },
                ]
            }
        }
    },
    methods:{
        // 获取列表
        getList(){
            viewSignDeploy({tpl_id:this.$route.query.tpl_id}).then(res=>{
                if (res.code==200){
                    this.data=res.data.list;
                    this.page.total=res.data.count;
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        // 取消
        cancelBtn(){
            this.dialogVisible=false
            this.$refs.form.resetFields()
        },
        // 新增签署方
        addBtn(){
            if (this.form.zt_name==''){
                this.$message.error('请输入主体名称代号');
                return false
            }else {
                addSignDeploy(this.form).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.dialogVisible=false;
                        this.getList()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        // 编辑签署方
        editBtn(row){
            this.editForm.id=row.id;
            this.editForm.zt_name=row.zt_name;
            this.editForm.zt_type=row.zt_type;
            this.dialogVisible_edit = true
        },
        // 确认编辑
        confirmEdit(){
            if (this.editForm.zt_name==''){
                this.$message.error('请输入主体名称代号');
                return false
            }else {
                editSignDeploy(this.editForm).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.dialogVisible_edit=false;
                        this.getList()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        // 删除签署方
        deleteBtn(row){
            this.$confirm('请确认是否删除该签署方 ', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteSignDeploy({id:row.id}).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.getList()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => {

            });
        },
        // 下一步
        nextBtn(){
            nextEditTemplate({id:this.$route.query.tpl_id}).then(res=>{
                if (res.code==200){
                    window.open(res.data.docTemplateEditUrl,'_blank')
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    },
    created() {
        this.form.tpl_id=this.$route.query.tpl_id;
        this.getList()
    }
}
</script>

<style scoped>
    .signDeployBox{
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
    }
    .pull-down{
        padding: 10px 30px;
    }
</style>